import { createActionsHook } from 'src/lib/sweetState';

import { ImageStyleStore } from './ImageStyleStore';

export const useImageStyleActions = createActionsHook(ImageStyleStore);
